import { observer } from 'mobx-react-lite'

import { Icon } from '@mxenabled/mx-icons'

import { useGlobalCopyStore } from '../../common'

import { useBeatActions } from '../beatActions'

import { OverflowMenu, type OverflowMenuItem } from './OverflowMenu'

/** Overflow menu for insight cards. */
export const InsightOptionsMenu = observer(() => {
  const { onMenuAction } = useBeatActions()
  const copy = useGlobalCopyStore().insights_feed?.overflow_menu

  if (!onMenuAction || !copy) return null

  const { onAction, onOpen, disabled } = onMenuAction

  const items: OverflowMenuItem[] = [
    {
      key: 'helpful',
      icon: <Icon name="thumb_up" size={24} sx={{ color: 'action.active' }} />,
      label: copy.helpful,
      onSelect: () => onAction('helpful'),
    },
    {
      key: 'not_helpful',
      icon: <Icon name="thumb_down" size={24} sx={{ color: 'action.active' }} />,
      label: copy.not_helpful,
      onSelect: () => onAction('not_helpful'),
    },
    {
      key: 'hide',
      icon: <Icon name="visibility_off" size={24} sx={{ color: 'action.active' }} />,
      label: copy.hide,
      onSelect: () => onAction('hide'),
    },
  ]

  return (
    <OverflowMenu ariaLabel={copy.aria_label} disabled={disabled} items={items} onOpen={onOpen} />
  )
})

export default InsightOptionsMenu
